import React, { createContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CollectRequest } from '../../components/CollectRequest';
import { Header } from '../../components/Header';
import { HomeCarousel } from '../../components/HomeCarousel';
import { Container, Content } from './styled';

export const HomeContext = createContext({});

// build BFF

const Home = () => {
  const [cnpj, setCnpj] = useState('');

  const history = useHistory();

  const handleChangeCnpj = (event) => {
    setCnpj(event.target.value);
  };

  const contextValues = { cnpj, handleChangeCnpj };

  useEffect(() => {
    history.push('/signin');
  }, []);

  return (
    <HomeContext.Provider value={contextValues}>
      <Container>
        {/* <Header /> */}
        <HomeCarousel />
        <CollectRequest />
        <Content />
      </Container>
    </HomeContext.Provider>
  );
};

export default Home;
